import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
// import Sidebar from '../../components/Sidebar';
import AlertMessage from "../../AlertMessage";
import PermissionAccess from "./PermissionAccess";
// import Defaultsettings from "./Defaultsettings";

const Defaultsettings = () => {
  const [defaultYear, setDefaultYear] = useState("");
  const [defaultCurrentClass, setDefaultCurrentClass] = useState("");
  const [defaultAdmissionClass, setDefaultAdmissionClass] = useState("");
  const [years, setYears] = useState([]);
  const [language, setLanguage] = useState(localStorage.getItem("language"));
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const navigate = useNavigate();
  
  const [showPage, setShowPage] = useState('settings');

  const [isSchool, setIsSchool] = useState(false);
  const [isCollege, setIsCollege] = useState(false);
  const [isPrincipal, setIsPrincipal] = useState(false);
  const [isDean, setIsDean] = useState(false);

const [isHeadmaster, setIsHeadmaster] = useState(false);


  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);

  
      const openIndexedDB = () => {
        return new Promise((resolve, reject) => {
          const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version
    
          request.onerror = (event) => {
            console.error("IndexedDB error:", event.target.error);
            reject("Error opening IndexedDB");
          };
    
          request.onsuccess = (event) => {
            resolve(event.target.result);
          };
    
          request.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains('studentData')) {
              db.createObjectStore('studentData', { keyPath: 'id' });
            }
          };
        });
      };
  



 useEffect(() => {
  const fetchDefaultYear = async () => {
    try {
      const db = await openIndexedDB();
      const transaction = db.transaction(['defaultSettings'], 'readonly');
      const objectStore = transaction.objectStore('defaultSettings');
      const request = objectStore.get('defaultSettings');
  
      request.onsuccess = (event) => {
        const defaultSetting = event.target.result;
        
        if (defaultSetting) {
          setDefaultYear(defaultSetting.defaultYear || "");
          setDefaultCurrentClass(defaultSetting.defaultCurrentClass || "");
          setDefaultAdmissionClass(defaultSetting.defaultAdmissionClass || "");
          setIsSchool(defaultSetting.isSchool || false);
          setIsCollege(defaultSetting.isCollege || false);
          setIsPrincipal(defaultSetting.isPrincipal || false);
          setIsDean(defaultSetting.isDean || false);
          setIsHeadmaster(defaultSetting.isHeadmaster || false); // Add this line
        } else {
          console.warn("No default settings found for the key 'defaultSettings'.");
        }
      };
    
        request.onerror = (event) => {
          console.error("Error fetching default settings:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching default year:', error);
      }
    };
    fetchDefaultYear();

    // Generate years for dropdown in the format "1990-1991" to "2040-2041"
    const startYear = 1990;
    const endYear = 2040;
    const generatedYears = Array.from(
      { length: endYear - startYear + 1 },
      (_, index) => {
        const year = startYear + index;
        return `${year}-${year + 1}`;
      }
    );
    setYears(generatedYears);
  }, [udiseNumber]);

  const storeDefaultSettingsData = async (settings) => {
    try {
      const db = await openIndexedDB();
      const transaction = db.transaction(['defaultSettings'], 'readwrite');
      const store = transaction.objectStore('defaultSettings');
  
      // Use a fixed key for the default settings
      const request = store.put({
        id: 'defaultSettings', // Use a unique key for the settings
        defaultYear: settings.defaultYear,
        defaultCurrentClass: settings.defaultCurrentClass,
        defaultAdmissionClass: settings.defaultAdmissionClass,
        
        isSchool: settings.isSchool,
        isCollege: settings.isCollege,
        isPrincipal: settings.isPrincipal,
        isDean: settings.isDean,
              isHeadmaster: settings.isHeadmaster, // Add this line

      });
  
      request.onsuccess = () => {
        console.log("Default settings updated successfully in IndexedDB");
      };
  
      request.onerror = (e) => {
        console.error("Error updating default settings in IndexedDB:", e.target.error);
      };
    } catch (error) {
      console.error("Error initializing DB for default settings data:", error);
    }
  };
  
  const handleSubmit = async (event) => {
    event.preventDefault(); 

    const settings = {
      defaultYear,
      defaultCurrentClass,
      defaultAdmissionClass,
      isSchool,
      isCollege,
      isPrincipal,
      isDean,
       isHeadmaster, // Add this line
    };
    try {
      await axios.put(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/defaultSettings.json`,
        settings
      );
      await storeDefaultSettingsData(settings);
      setAlertMessage("Default settings saved successfully!");
    } catch (error) {
      console.error("Error saving default settings:", error);
      setAlertMessage("Failed to save default settings.");
    }
  };
  const changeLanguage = () => {
    const newLanguage = language === "English" ? "Marathi" : "English";
    setLanguage(newLanguage);
    localStorage.setItem("language", newLanguage);
    window.location.reload(); // Reload the page to reflect the language change
  };
  // const [activeButton, setActiveButton] = useState(null);
  
  const handleSettingsClick = () => {
    setShowPage("settings"); // Show the Settings page
  };

  // Handle the button click to show the Permissions page
  // const handlePermissionsClick = () => {
  //   // setShowPage("permissions"); // Show the Permissions page
  //   navigate('/persmissionaccess')
  // };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        className="main-content-of -page"
        style={{
          width: "600px",
          border: "1px solid #ccc",
          borderRadius: "10px",
          padding: "20px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.4)",
          marginTop: "110px",
          marginBottom: "48px",
        }}
      >
        <div style={{ padding: "20px" }}>
        {/* <div
      style={{
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center', borderBottom:'1px solid rgba(155 ,153 ,153 , 0.4)', paddingBottom:'20px', marginBottom:'40px'
      }}
    >
      <div
        style={{
          marginTop: '20px',
          display: 'flex',
          transition: 'width 0.4s ease',
          border: '1px solid #008CBA', height:'40px',
           width: '200px',
          borderRadius: '25px',

        }}
      > */}
        {/* <button
          onClick={handleSettingsClick}
          style={{
            padding: '10px 20px',
            // backgroundColor: showPage === 'settings' ? '#008CBA' : 'white', 
            backgroundColor:'#008CBA',
            color: 'white' , 

            border: 'none',
            borderRadius:'25px',
            // borderRadius: showPage === 'settings' ? '25px' : '25px 0px 0px 25px', 
            fontSize: '16px',
            transition: 'all 0.4s ease', width:'400px'
          }}
        >
            {language === "English"
            ? "Settings"
            : "सेटिंग्ज "}
        </button> */}
        {/* <button
          onClick={handlePermissionsClick}
          style={{
            padding: '10px 20px',
            backgroundColor: showPage === 'settings' ? 'white' : '#008CBA', 
            color: showPage === 'settings' ? '#008CBA' : 'White', 
            paddingLeft:'10px',
            border: 'none',
            borderRadius: showPage === 'permissions' ? '25px' : '0px 25px 25px 0px', 
            fontSize: '16px',
            transition: 'all 0.4s ease',   width: language === 'English' ? '125px' : '100px', 
          }}
        >
           {language === "English"
            ? "Permissions"
            : "परवानगी "}
        </button> */}
      {/* </div>
    </div> */}

          {showPage === "settings" && (
            <div style={{ marginTop: "20px" }}>
            <h4
          style={{
            textAlign: "center",
            color: "rgb(3, 54, 94)",
            marginTop: "10px",
            marginBottom: "20px",
            fontWeight: "600",
          }}
        >
          {" "}
          {language === "English"
            ? "Set Default Settings"
            : "डिफॉल्ट सेटिंग्ज सेट करा"}
        </h4>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label
              htmlFor="defaultYear"
              className="form-label"
              style={{ fontWeight: "bold", color: "#555", marginBottom: "5px" }}
            >
              {" "}
              {language === "English" ? "Set Year" : "वर्ष सेट करा"}{" "}
            </label>
            <select
              id="defaultYear"
              className="form-select"
              value={defaultYear}
              onChange={(e) => setDefaultYear(e.target.value)}
              style={{
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "100%",
                height: "37px",
              }}
            >
              <option value="">Select Year</option>
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <label
              htmlFor="defaultClass"
              className="form-label"
              style={{ fontWeight: "bold", color: "#555", marginBottom: "5px" }}
            >
              {" "}
              {language === "English"
                ? "Set Current Class"
                : "सध्याचा वर्ग सेट करा"}{" "}
            </label>
            <select
              id="defaultCurrentClass"
              className="form-select"
              value={defaultCurrentClass}
              onChange={(e) => setDefaultCurrentClass(e.target.value)}
              style={{
                padding: "8px",
                height: "37px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "100%",
              }}
            >
              <option value="">{language === "English" ? "Select Class" : "वर्ग निवडा"}</option>
              <option
                value={language === "English" ? "Class I" : "इयत्ता पहिली"}
              >
                {" "}
                {language === "English" ? " Class I " : "इयत्ता पहिली"}
              </option>
              <option
                value={language === "English" ? "Class II" : "इयत्ता दुसरी"}
              >
                {" "}
                {language === "English" ? " Class II " : "इयत्ता दुसरी"}
              </option>
              <option
                value={language === "English" ? "Class III" : "इयत्ता तिसरी"}
              >
                {" "}
                {language === "English" ? " Class III " : "इयत्ता तिसरी"}
              </option>
              <option
                value={language === "English" ? "Class IV" : "इयत्ता चौथी"}
              >
                {" "}
                {language === "English" ? " Class IV " : "इयत्ता चौथी"}
              </option>
              <option
                value={language === "English" ? "Class V" : "इयत्ता पाचवी"}
              >
                {" "}
                {language === "English" ? " Class V " : "इयत्ता पाचवी"}
              </option>
              <option
                value={language === "English" ? "Class VI" : "इयत्ता सहावी"}
              >
                {" "}
                {language === "English" ? " Class VI " : "इयत्ता सहावी"}
              </option>
              <option
                value={language === "English" ? "Class VII" : "इयत्ता सातवी"}
              >
                {" "}
                {language === "English" ? " Class VII " : "इयत्ता सातवी"}
              </option>
              <option
                value={language === "English" ? "Class VIII" : "इयत्ता आठवी"}
              >
                {" "}
                {language === "English" ? " Class VIII " : "इयत्ता आठवी"}
              </option>
              <option
                value={language === "English" ? "Class IX" : "इयत्ता नववी"}
              >
                {" "}
                {language === "English" ? " Class IX " : "इयत्ता नववी"}
              </option>
              <option
                value={language === "English" ? "Class X" : "इयत्ता दहावी"}
              >
                {" "}
                {language === "English" ? " Class X " : "इयत्ता दहावी"}
              </option>
              <option
                value={language === "English" ? "Class XI" : "इयत्ता अकरावी"}
              >
                {" "}
                {language === "English" ? " Class XI " : "इयत्ता अकरावी"}
              </option>
              <option
                value={language === "English" ? "Class XII" : "इयत्ता बारावी"}
              >
                {" "}
                {language === "English" ? " class XII" : "इयत्ता बारावी"}
              </option>
            </select>
          </div>

          <div className="mb-3">
            <label
              htmlFor="defaultClass"
              className="form-label"
              style={{ fontWeight: "bold", color: "#555", marginBottom: "5px" }}
            >
              {" "}
              {language === "English"
                ? "Set Admission Class"
                : "प्रवेश  वर्ग सेट करा"}{" "}
            </label>
            <select
              id="defaultClass"
              className="form-select"
              value={defaultAdmissionClass}
              onChange={(e) => setDefaultAdmissionClass(e.target.value)}
              style={{
                padding: "8px",
                height: "37px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "100%",
              }}
            >
              <option value="">{language === "English" ? "Select Class" : "वर्ग निवडा"}</option>
              <option
                value={language === "English" ? "Class I" : "इयत्ता पहिली"}
              >
                {" "}
                {language === "English" ? " Class I " : "इयत्ता पहिली"}
              </option>
              <option
                value={language === "English" ? "Class II" : "इयत्ता दुसरी"}
              >
                {" "}
                {language === "English" ? " Class II " : "इयत्ता दुसरी"}
              </option>
              <option
                value={language === "English" ? "Class III" : "इयत्ता तिसरी"}
              >
                {" "}
                {language === "English" ? " Class III " : "इयत्ता तिसरी"}
              </option>
              <option
                value={language === "English" ? "Class IV" : "इयत्ता चौथी"}
              >
                {" "}
                {language === "English" ? " Class IV " : "इयत्ता चौथी"}
              </option>
              <option
                value={language === "English" ? "Class V" : "इयत्ता पाचवी"}
              >
                {" "}
                {language === "English" ? " Class V " : "इयत्ता पाचवी"}
              </option>
              <option
                value={language === "English" ? "Class VI" : "इयत्ता सहावी"}
              >
                {" "}
                {language === "English" ? " Class VI " : "इयत्ता सहावी"}
              </option>
              <option
                value={language === "English" ? "Class VII" : "इयत्ता सातवी"}
              >
                {" "}
                {language === "English" ? " Class VII " : "इयत्ता सातवी"}
              </option>
              <option
                value={language === "English" ? "Class VIII" : "इयत्ता आठवी"}
              >
                {" "}
                {language === "English" ? " Class VIII " : "इयत्ता आठवी"}
              </option>
              <option
                value={language === "English" ? "Class IX" : "इयत्ता नववी"}
              >
                {" "}
                {language === "English" ? " Class IX " : "इयत्ता नववी"}
              </option>
              <option
                value={language === "English" ? "Class X" : "इयत्ता दहावी"}
              >
                {" "}
                {language === "English" ? " Class X " : "इयत्ता दहावी"}
              </option>
              <option
                value={language === "English" ? "Class XI" : "इयत्ता अकरावी"}
              >
                {" "}
                {language === "English" ? " Class XI " : "इयत्ता अकरावी"}
              </option>
              <option
                value={language === "English" ? "Class XII" : "इयत्ता बारावी"}
              >
                {" "}
                {language === "English" ? " class XII" : "इयत्ता बारावी"}
              </option>
            </select>
          </div>

         <div className="mb-3" style={{ display: "flex", "justifyContent": "left" }}>
              <label style={{ fontWeight: "bold", color: "#555", marginBottom: "5px",   marginRight: language === "English" ? "78px" : "105px", }}>
                {language === "English" ? "Institution Type" : "संस्थान प्रकार"}
              </label>
              <div style={{ display:'flex'}}>
                <label style={{ display:'flex'}}>
                  <input
                    type="checkbox"
                    checked={isSchool} style={{marginBottom:'6px', marginRight:'6px'}}
                    onChange={() => setIsSchool(!isSchool)}
                  />
                  {language === "English" ? "School" : "शाळा"}
                </label>
                <label style={{ marginLeft:language==="English"?  '38px' :"74px" , display:'flex'}}>
                  <input
                    type="checkbox"
                    checked={isCollege} style={{marginBottom:'6px', marginRight:'6px'}}
                    onChange={() => setIsCollege(!isCollege)}
                  />
                  {language === "English" ? "College" : "कॉलेज"}
                </label>
              </div>
            </div>
          <hr/>
            <div className="mb-3" style={{ display: "flex", justifyContent: "left"}}>
  <label style={{ fontWeight: "bold", color: "#555", marginBottom: "5px", marginRight: language === "English" ? "70px" : "40px" }}>
    {language === "English" ? "Authority of Sign" : "स्वाक्षरीचा अधिकार"}
  </label>
  <div style={{ display:'flex', flexWrap: 'wrap', gap: '20px' }}>
    <label style={{ display:'flex'}}>
      <input
        type="checkbox"
        checked={isPrincipal} 
        style={{marginBottom:'6px', marginRight:'6px'}}
        onChange={() => setIsPrincipal(!isPrincipal)}
      />
      {language === "English" ? "Principal" : "प्राचार्य"}
    </label>
    <label style={{ display:'flex'}}>
      <input
        type="checkbox"
        checked={isDean} 
        style={{marginBottom:'6px', marginRight:'6px'}}
        onChange={() => setIsDean(!isDean)}
      />
      {language === "English" ? "Dean" : "डीन"}
    </label>
    <label style={{ display:'flex'}}>
      <input
        type="checkbox"
        checked={isHeadmaster} 
        style={{marginBottom:'6px', marginRight:'6px'}}
        onChange={() => setIsHeadmaster(!isHeadmaster)}
      />
      {language === "English" ? "Headmaster" : "मुख्याध्यापक"}
    </label>
  </div>
</div>
          <div style={{ textAlign: "center" }}>
            <button
              type="submit"
              style={{
                width: "100px",
                padding: "7px",
                backgroundColor: "green",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                fontSize: "17px",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
              }}
            >
              Save
            </button>
          </div>
        </form>
        <hr style={{marginTop:'20px'}}/> 
        <button
          onClick={changeLanguage}
          style={{
            backgroundColor: "rgb(187 145 44)",
            color: "#fff",
            padding: "8px 15px",
            border: "none",
            borderRadius: "20px",
            fontSize: "14px",
            fontWeight: "bold",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
            marginBottom:'-40px',
            marginTop:'20px'
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#ebb71a")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "rgb(187 145 44)")}
        >
          {language === "English" ? "Change to Marathi" : "इंग्रजीमध्ये बदला"}
        </button>
            </div>
          )}
          {/* {showPage === "permissions" && (
            <div style={{ marginTop: "20px"}}>
                <button onClick={handlePermissionsClick}>
                  {language === "English" ? "Permissions" : "परवानगी"}
                </button>
            </div>
          )} */}
        </div>
        <AlertMessage message={alertMessage} show={showAlert} />
      </div>
    </div>
  );
};

export default Defaultsettings;
